/* La striscia del backup: solo per l'amministratore, solo se c'e' qualcosa da
 * sapere.
 *
 * **Perche' una striscia e non un'email**: un avviso mandato dal job non copre
 * il guasto peggiore, quello in cui il job non gira affatto. Qui si guarda
 * l'eta' dell'ultimo backup nell'archivio (vedi `jobs/backup_notturno.py`), e le
 * due o tre persone che usano il programma entrano ogni giorno. Il testo lo
 * scrive il server; l'interfaccia non decide cosa e' grave.
 *
 * **Se la domanda stessa fallisce** si dice, invece di tacere: una striscia
 * assente perche' il controllo non ha risposto sarebbe un "va tutto bene" non
 * guadagnato.
 */

import { backup, type Ruolo } from "../api";
import { useCarica } from "../carica";

const ORA = new Intl.DateTimeFormat("it-IT", {
  weekday: "long",
  day: "numeric",
  month: "long",
  hour: "2-digit",
  minute: "2-digit",
});

export function AvvisoBackup({ ruolo }: { ruolo: Ruolo }) {
  const amministratore = ruolo === "AMMINISTRATORE";
  const stato = useCarica(
    () => (amministratore ? backup.stato() : Promise.resolve(null)),
    [amministratore],
  );
  if (!amministratore || stato.inCorso) return null;

  if (stato.errore) {
    return (
      <aside className="avviso-backup" role="status" aria-label="Backup">
        <strong>Backup.</strong> Non sono riuscito a controllare se i dati hanno una copia.
      </aside>
    );
  }
  if (!stato.dati?.da_segnalare) return null;

  return (
    <aside className="avviso-backup" role="status" aria-label="Backup">
      <strong>Backup.</strong> {stato.dati.messaggio}
      {stato.dati.ultimo && <> Ultima copia: {ORA.format(new Date(stato.dati.ultimo))}.</>}
    </aside>
  );
}
